import DataTableColumnHeader from '@/components/datatable/DataTableColumnHeader.vue';
import EmployeeChangesTableActions from '@/components/employees/EmployeeChangesTableActions.vue';
import EmployeeTableActions from '@/components/employees/EmployeeTableActions.vue';
import StatusIndicator from '@/components/StatusIndicator.vue';
import { useDateFormat } from '@/composables/useDateFormat';
import type { Employee } from '@/types';
import type { ColumnDef } from '@tanstack/vue-table';
import { h } from 'vue';

const { formatDMYFromIso } = useDateFormat();

export const columns: ColumnDef<Employee>[] = [
    {
        accessorKey: 'company_id',
        enableColumnFilter: false,
    },
    {
        accessorKey: 'full_name',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'employee.table.full_name',
            }),
    },
    {
        accessorKey: 'employment_date',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'employee.table.employment_date',
            }),
        cell: ({ row }) => {
            return formatDMYFromIso(row.original.employment_date);
        },
        filterFn: 'dateRange',
        meta: {
            filterType: 'dateRange',
        },
    },
    {
        accessorKey: 'termination_date',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'employee.table.termination_date',
            }),
        cell: ({ row }) => {
            return formatDMYFromIso(row.original.termination_date);
        },
        filterFn: 'dateRange',
        meta: {
            filterType: 'dateRange',
        },
    },
    {
        accessorKey: 'cards_assigned',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'employee.table.cards_assigned',
            }),
    },
    {
        id: 'user',
        accessorFn: (row) => (row.user_id ? 1 : 0),
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'employee.table.user',
            }),
        cell: ({ row }) => {
            return h(StatusIndicator, {
                active: !!row.original.user_id,
                type: 'yesNo',
            });
        },
        filterFn: 'boolean',
        meta: {
            filterType: 'yesNo',
        },
    },
    {
        accessorKey: 'changes',
        enableColumnFilter: false,
        enableSorting: false,
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'employee.table.changes',
            }),
        cell: ({ row }) => {
            return h(EmployeeChangesTableActions, {
                employee: row.original,
            });
        },
    },
    {
        id: 'actions',
        enableHiding: false,
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'employee.table.actions',
            }),
        cell: ({ row }) => {
            return h(EmployeeTableActions, {
                employee: row.original,
            });
        },
    },
];
